import {
	TChangeSubCategoryPositionSelectedRestaurant,
	TChangeSubCategoryPositionSelectedItem,
	TTypeOfChangeSubCategoryPositionModalWindow,
} from './changeSubCategoryPositionContext';
import { ISubCategoryPositionItem } from 'types';

export enum ChangeSubCategoryPositionActionTypes {
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_RESTAURANT = 'SET_RESTAURANT',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_POSITIONS_DATA = 'SET_POSITIONS_DATA',
	REORDER_ITEMS = 'REORDER_ITEMS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL = 'SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL',
	TOGGLE_APPLY_TO_ONE = 'TOGGLE_APPLY_TO_ONE',
	SET_ADDITIONAL_RESTAURANTS = 'SET_ADDITIONAL_RESTAURANTS',
	CHANGE_SELECT_SEARCH_STRING = 'CHANGE_SELECT_SEARCH_STRING',
}

interface ISetIDCustomer {
	type: ChangeSubCategoryPositionActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: TChangeSubCategoryPositionSelectedItem;
	};
}

interface ISetRestaurant {
	type: ChangeSubCategoryPositionActionTypes.SET_RESTAURANT;
	payload: {
		selectedRestaurant: TChangeSubCategoryPositionSelectedRestaurant | null;
	};
}

interface ISetIDCategory {
	type: ChangeSubCategoryPositionActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: TChangeSubCategoryPositionSelectedItem;
	};
}

interface IResetSelectedControls {
	type: ChangeSubCategoryPositionActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetPositionsData {
	type: ChangeSubCategoryPositionActionTypes.SET_POSITIONS_DATA;
	payload: {
		positionsData: ISubCategoryPositionItem[];
	};
}

interface IReorderItems {
	type: ChangeSubCategoryPositionActionTypes.REORDER_ITEMS;
	payload: {
		newOrder: ISubCategoryPositionItem[];
	};
}

interface IChangeTypeOfModalWindow {
	type: ChangeSubCategoryPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfChangeSubCategoryPositionModalWindow;
	};
}

interface ISetVisibleAdditionalRestaurantsModal {
	type: ChangeSubCategoryPositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL;
	payload: {
		isVisible: boolean;
		isApplyToOne: boolean;
		selectedAdditionalRestaurants: TChangeSubCategoryPositionSelectedRestaurant[];
		selectSearchString: string;
	};
}

interface IToggleApplyToOne {
	type: ChangeSubCategoryPositionActionTypes.TOGGLE_APPLY_TO_ONE;
}

interface ISetAdditionalRestaurants {
	type: ChangeSubCategoryPositionActionTypes.SET_ADDITIONAL_RESTAURANTS;
	payload: {
		additionalRestaurants: TChangeSubCategoryPositionSelectedRestaurant[];
	};
}

interface IChangeSelectSearchString {
	type: ChangeSubCategoryPositionActionTypes.CHANGE_SELECT_SEARCH_STRING;
	payload: {
		searchString: string;
	};
}

export type TChangeSubCategoryPositionActions =
	| ISetIDCustomer
	| ISetRestaurant
	| ISetIDCategory
	| IResetSelectedControls
	| ISetPositionsData
	| IReorderItems
	| IChangeTypeOfModalWindow
	| ISetVisibleAdditionalRestaurantsModal
	| IToggleApplyToOne
	| ISetAdditionalRestaurants
	| IChangeSelectSearchString;
